<template>
    <div class="custom-select" :tabindex="tabindex" @blur="open = false">
      <div class="selected" :class="{ open: open, 'validate-error': showError }" @click="open = !open" :style="{width: selectedWidth, backgroundColor: backgroundColor}">
        <span :class="{'selected-label': selected !== this.defaultLabel}">{{ selected }}</span>
        <div class="arrow-wrapper" :style="{backgroundColor: themeColor}">
          <div class="select-arrow" :class="[open ? 'select-arrow-rotated' : 'select-arrow-unrotated']"></div>
        </div>
      </div>
      <div class="items-container" :class="{ selectHide: !open }" :style="{width: itemsWidth, marginLeft: itemsMl, backgroundColor: backgroundColor}">
        <div
          class="select-item"
          v-for="(option, i) of options"
          :key="i"
          @click="
            selected = option.value;
            open = false;
            $emit('input', option);
          "
        >
          <span class="select-item-label">{{ option.value }}</span>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      saved: {
        type: Boolean,
        default: false
      },
      options: {
        type: Array,
        required: true,
      },
      defaultLabel: {
        type: String,
        required: false
      },
      defaultSelected: {
        type: String,
        required: false,
        default: null,
      },
      tabindex: {
        type: Number,
        required: false,
        default: 0,
      },
      rowid: {
        type: [Number, String],
        required: false
      },
      itemsWidth: {
        type: String,
        required: false,
        default: '100%'
      },
      itemsMl: {
        type: String,
        required: false,
        default: '0px'
      },
      selectedWidth: {
        type: String,
        required: false,
        default: '100%'
      },
      themeColor: {
        type: String,
        required: false,
        default: '#ADCB99'
      },
      backgroundColor: {
        type: String,
        required: false,
        default: '#E4F4F9'
      },
      showError: {
        required: false,
        default: false
      }
    },
    data() {
      return {
        selected: this.defaultSelected ? this.defaultSelected : this.defaultLabel,
        open: false,
      };
    },
    watch: {
      defaultSelected(newVal, oldVal) {
        this.selected = newVal ? newVal : this.defaultLabel;
      },
      saved(val) {
        if (val) {
          this.selected = this.defaultLabel;
          this.$emit("saved-options", false);
        }
      },
    }
  };
  </script>
  
  <style scoped>
  .custom-select {
    position: relative;
    width: 100%;
    text-align: left;
    outline: none;
  }
  
  /* .custom-select .selected-label {
    font-family: 'content';
  } */
  
  .custom-select .selected {
    display: flex;
    align-items: center;
    width: 140px;
    height: 35px;
    font-size:13px;
    background-color: #FFFFFF;
    border-radius: 15px 20px 20px 0px;
    color: #3B3B3B;
    padding-left: 14px;
    cursor: pointer;
    user-select: none;
    font-family: 'MyriadPro';
    letter-spacing: 0.04px;
    line-height: 1;
  }
  
  .arrow-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 35px;
    height: 35px;
    background-color: #ADCB99;
    border-radius: 16px 16px 16px 0px;
    margin-left: auto;
    margin-right: 0px;
  }
  
  .arrow-wrapper .select-arrow {
    width: 0; 
    height: 0; 
    border-left: 11px solid transparent;
    border-right: 11px solid transparent;
    border-top: 11px solid #FFFFFF;
  } 
  
  .arrow-wrapper .select-arrow-rotated {
    transform: rotate(180deg);
    transition: all 0.2s;
  }
  
  .arrow-wrapper .select-arrow-unrotated {
    transition: all 0.2s;
  }
  
  .custom-select .items-container {
    position: absolute;
    left: 0;
    right: 0;
    font-size: 13px;
    width: 100%;
    border-radius: 20px 0 20px 20px;
    box-shadow: 0 5px 6px rgb(0 0 0 / 25%);
    background-color: white;
    padding: 15px 25px 20px 25px;
    z-index: 1;
    max-height: 400px;
    overflow-y: auto;
    margin-top: 10px;
  }
  
  .custom-select .items-container .select-item{
    cursor: pointer;
    border-bottom: 1px solid #99dae8;
    padding-top: 12px;
    padding-bottom: 12px;
    color: #404142;
  }
  .custom-select .items-container .select-item:last-of-type{
    border-bottom: none;
    padding-bottom: 0px;
  }
  
  .custom-select .items-container .select-item .select-item-label{
    margin-left: 5px;
  }
  
  .selectHide {
    display: none;
  }
  
  .purple .selected {
    color: #625895;
    background-color: #E5E3ED;
    border-radius: 10px 12px 12px 0px;
  }
  
  .purple .arrow-wrapper {
    background-color: #625895;
  }
  
  .purple .items-container .select-item {
    border-bottom: 1px solid #E5E3ED;
  }
  
  .validate-error {
    border: 1px solid #F07D2C;
  }
  </style>
  